import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { callBackend } from "../components/callBackend";
import { Container } from "react-bootstrap";
import DataTable from "../components/DataTable";
import EventsCatalog from "../data/events-catalog.json";
import { toast } from "react-toastify";
import DownloadButton from "../components/DownloadButton";
import Loader from "../components/Loader"; // 1. Import the Loader

export default function EventRegData() {
    const { eid } = useParams();
    const eventInfo = EventsCatalog[eid];

    const [count, setCount] = useState(0);
    const [partData, setPartData] = useState([]);
    const [role, setRole] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    let pref = JSON.parse(localStorage.getItem("nssc-admin-pref"));
    const [tableControls, setTableControls] = useState(
        pref && pref.pageID == 10 + Number(eid) && pref.v === 2
            ? pref
            : {
                  page: 1,
                  length: 100,
                  sortField: "_id",
                  sortDir: -1,
                  search: "",
              }
    );

    const isTeamEvent = eventInfo ? !!eventInfo.team : eid > 3;

    let columns =
        !isTeamEvent
            ? {
                  _id: "Sl. No.",
                  pid: "PID",
                  fName: "First Name",
                  lName: "Last Name",
                  college: "College/School",
                  email: "Email",
                  roll: "De-Reg",
              }
            : {
                  _id: "Sl. No.",
                  teamID: "Team ID",
                  teamName: "Team Name",
                  pids: "Participant IDs",
                  eventID: "De-Reg",
              };

    let downloadHeaders = [
        { label: "PID", key: "pid" },
        { label: "First Name", key: "fName" },
        { label: "Last Name", key: "lName" },
        { label: "Email Address", key: "email" },
        { label: "Phone Number", key: "phone" },
        { label: "Gender", key: "gender" },
        { label: "Level of Study", key: "level" },
        { label: "Name of Institution", key: "college" },
        { label: "Payment Status", key: "paymentStatus" },
    ];

    if (isTeamEvent) {
        downloadHeaders.push({ label: "Team ID", key: "teamID" });
        downloadHeaders.push({ label: "Team Name", key: "teamName" });
    }

    if (eventInfo && eventInfo.isSub) {
        if (!isTeamEvent) {
            columns = {
                ...columns,
                events: eid == 2 ? "Hackerank Username" : "Submission",
            };
            downloadHeaders.push({ label: "Submission", key: "submission" });
        } else {
            columns = {
                ...columns,
                subLink: "Submission Link",
            };
            downloadHeaders.push({ label: "Submission", key: "subLink" });
        }
    }

    const getPartData = () => {
        if (!localStorage.getItem("nssc-admin-token")) {
            window.location.href = "/login";
            return;
        }
        setIsLoading(true); // Show loader for every fetch
        callBackend({
            method: "GET",
            endpoint: "/admin/events/" + eid + "/",
            data:
                "sortField=" +
                tableControls.sortField +
                "&sortDir=" +
                tableControls.sortDir +
                "&first=" +
                (0 + tableControls.length * (tableControls.page - 1)) +
                "&limit=" +
                tableControls.length +
                "&search=" +
                encodeURIComponent(tableControls.search || ""),
            onSuccess: (res) => {
                setPartData(res.data);
                setCount(res.count);
                setRole(res.role);
                setIsLoading(false); // Hide loader on success
            },
            onError: (error) => {
                console.error("Failed to fetch event data:", error);
                toast.error("Failed to fetch data.");
                setIsLoading(false); // Hide loader on error
            },
        });
    };

    const deregister = async (pid) => {
        if (role < 2) {
            toast.error("You are not authorized to perform this action", {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "dark",
            });
            return;
        }

        if (confirm("Are you sure you want to deregister?")) {
            callBackend({
                method: "POST",
                endpoint: "/admin/events/delete/",
                data: {
                    eid: eid,
                    pid: pid,
                },
                onSuccess: (res) => {
                    getPartData();
                },
            });
        }
    };

    useEffect(() => {
        setTableControls(
            pref && pref.pageID == 10 + Number(eid) && pref.v === 2
                ? pref
                : { page: 1, length: 100, sortField: "_id", sortDir: -1, search: "" }
        );
        // getPartData() is called by the tableControls useEffect, 
        // so it's not strictly needed here, but it ensures data loads
        // if tableControls doesn't change when eid does.
        getPartData(); 
    }, [eid]);

    useEffect(() => {
        getPartData();
        localStorage.setItem(
            "nssc-admin-pref",
            JSON.stringify({ ...tableControls, pageID: 10 + Number(eid), v: 2 })
        );
    }, [tableControls]);

    if (!eventInfo) {
        return (
            <Container style={{ marginTop: "20px", marginBottom: "20px" }}>
                <h1>Event not found</h1>
                <p>No event with id "{eid}" in the current catalog.</p>
            </Container>
        );
    }

    return (
        <Container fluid style={{ marginTop: "20px", marginBottom: "20px" }}>
            <h1>{eventInfo.name}</h1>
            {eventInfo.team && (
                <p>
                    Max team size : {eventInfo.max} | Min team size :{" "}
                    {eventInfo.min}
                </p>
            )}

            {/* Conditionally render Loader or DataTable */}
            {isLoading ? (
                <Loader />
            ) : (
                <DataTable
                    eid={eid}
                    columns={columns}
                    data={partData}
                    count={count}
                    tableControls={tableControls}
                    setTableControls={setTableControls}
                    deregister={deregister}
                    downloadButton={
                        <DownloadButton
                            endpoint={"/admin/download/event/" + eid + "/"}
                            downloadHeaders={downloadHeaders}
                        />
                    }
                />
            )}
        </Container>
    );
}